import {IVehicleOnBoardActionTypes,IVehicleOnBoardActionCreator} from 'models/IVehicleonBoardState';

const initialState:any = {
    is_api_in_request: false,
    status:null,
    message: ''
}

const reducer = (state = initialState, { type, payload }: IVehicleOnBoardActionCreator) => {
    switch (type) {
        case IVehicleOnBoardActionTypes.DELETE_VEHICLE_REQUEST:
            return {
                ...initialState,
                is_api_in_progress: true
            }
        case IVehicleOnBoardActionTypes.DELETE_VEHICLE_REQUEST_SUCCESS:
            return {
                ...state,
                status:200,
                message: 'deleted vehicle successfully'
            }
        case IVehicleOnBoardActionTypes.DELETE_VEHICLE_REQUEST_FAILURE:
            return {
                ...state,
                is_api_in_progress:false,
                status:422,
                ...payload
            } 
        default:
            return state;
    }
};
  
  export default reducer;